/**
 * simpleCardDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

simpleCardDirective.$inject = [];

export function simpleCardDirective() {
    return {
        replace: true,
        restrict: 'E',
        transclude: true,
        // language=HTML
        template: `
            <md-card class="md-card--simple">
                <md-card-content></md-card-content>
            </md-card>
        `,
        compile: function(tElement, attr, transclude) {
            return function postLink(scope) {
                // Transclude the user-given contents of the subheader
                // the conventional way.
                transclude(scope, function(clone) {
                    getContent(tElement).append(clone);
                });
            };

            function getContent(el) {
                return angular.element(el[0].querySelector('md-card-content'));
            }
        },
    };
}
